import React from 'react';

const Logo = ({ 
  variant = 'full', 
  size = 'medium', 
  className = '', 
  onClick,
  animated = true 
}) => {
  const wordmarkSizes = {
    small: 'h-10 sm:h-11 md:h-12',
    medium: 'h-11 sm:h-12 md:h-14 lg:h-16',
    large: 'h-12 sm:h-14 md:h-16 lg:h-20',
    xlarge: 'h-14 sm:h-16 md:h-20 lg:h-24'
  };

  const wordmarkWidth = wordmarkSizes[size];

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div 
      className={`flex items-center ${className} ${onClick ? 'cursor-pointer' : ''} transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-transparent`}
      onClick={handleClick}
      role={onClick ? 'button' : 'img'}
      tabIndex={onClick ? 0 : undefined}
      aria-label="STAGSTER Logo"
    >
      <div className={`${wordmarkWidth} min-w-0 select-none flex items-center shrink-0`}>
        <picture className="block h-full">
          <source srcSet="/STAGSTER.webp" type="image/webp" />
          <source srcSet="/STAGSTER.svg" type="image/svg+xml" />
          <img
            src="/STAGSTER.webp"
            alt="STAGSTER logo"
            className="block h-full w-auto max-w-full"
            loading="lazy"
            width="227"
            height="77"
            onError={(event) => {
              event.currentTarget.style.display = 'none';
              if (event.currentTarget.nextSibling) {
                event.currentTarget.nextSibling.style.display = 'block';
              }
            }}
          />
        </picture>
        <span className="hidden w-full text-sm font-extrabold uppercase tracking-[0.18em] text-[#ec4899]">
          STAGSTER
        </span>
      </div>
    </div>
  );
};

export default Logo; 
